'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    _extends({ viewBox: '0 0 60 40' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: '#F3F4F4', d: 'M60,35c0,2.75-2.25,5-5,5H5c-2.75,0-5-2.25-5-5V5c0-2.75,2.25-5,5-5h50c2.75,0,5,2.25,5,5V35z' }),
      _react2.default.createElement('path', { fill: '#5666AF', d: 'M1,10V5c0-2.75,2.25-5,5-5h48c2.75,0,5,2.25,5,5v5' }),
      _react2.default.createElement('path', { fill: '#E6A226', d: 'M59,30v5c0,2.75-2.25,4-5,4H6c-2.75,0-5-1.25-5-4v-5' }),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { fill: '#5666AF', d: 'M17.387,23.379c0.406-1.15,0.691-1.887,0.859-2.211l3.375-6.875h2.469l-5.844,11.422h-2.609l-0.992-11.422 h2.305l0.398,6.875c0.02,0.234,0.031,0.582,0.031,1.039c-0.012,0.537-0.027,0.928-0.047,1.172H17.387z' }),
        _react2.default.createElement('path', { fill: '#5666AF', d: 'M23.059,25.715l2.438-11.422h2.383l-2.438,11.422H23.059z' }),
        _react2.default.createElement('path', { fill: '#5666AF', d: 'M35.184,22.34c0,1.09-0.387,1.949-1.156,2.582c-0.771,0.633-1.815,0.949-3.133,0.949 c-1.151,0-2.078-0.234-2.781-0.703v-2.141c1.004,0.562,1.938,0.844,2.797,0.844c0.582,0,1.039-0.109,1.366-0.332 c0.328-0.221,0.492-0.523,0.492-0.91c0-0.223-0.035-0.42-0.104-0.59c-0.069-0.168-0.172-0.326-0.301-0.473 c-0.132-0.146-0.453-0.41-0.97-0.797c-0.719-0.518-1.225-1.025-1.516-1.533c-0.293-0.505-0.438-1.049-0.438-1.633 c0-0.672,0.16-1.271,0.484-1.801c0.322-0.528,0.781-0.939,1.38-1.234c0.596-0.294,1.28-0.441,2.059-0.441 c1.129,0,2.164,0.258,3.102,0.773l-0.852,1.82c-0.812-0.385-1.562-0.578-2.25-0.578c-0.434,0-0.787,0.117-1.062,0.352 c-0.277,0.234-0.414,0.545-0.414,0.93c0,0.318,0.086,0.596,0.258,0.832c0.172,0.237,0.558,0.551,1.156,0.941 c0.629,0.417,1.102,0.877,1.414,1.379C35.027,21.082,35.184,21.668,35.184,22.34z' }),
        _react2.default.createElement('path', { fill: '#5666AF', d: 'M42.848,22.996h-3.695l-1.344,2.719h-2.5l5.984-11.469h2.914l1.148,11.469h-2.32L42.848,22.996z M42.73,20.965l-0.203-2.734c-0.053-0.682-0.078-1.341-0.078-1.977v-0.281c-0.23,0.625-0.514,1.287-0.852,1.984l-1.47,3.008H42.73 z' })
      ),
      _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M30,0' }),
      _react2.default.createElement('path', { opacity: '0.04', fill: '#FFFFFF', enableBackground: 'new    ', d: 'M58.531,1.469C59.438,2.375,60,3.625,60,5v15v15 c0,1.375-0.562,2.625-1.469,3.531C57.624,39.438,56.375,40,55,40H30H5c-1.375,0-2.625-0.562-3.531-1.469L58.531,1.469z' }),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { fill: '#F7F8F9', d: 'M55,1c2.206,0,4,1.794,4,4v30c0,2.206-1.794,4-4,4H5c-2.206,0-4-1.794-4-4V5c0-2.206,1.794-4,4-4H55 M55,0 H5C2.25,0,0,2.25,0,5v30c0,2.75,2.25,5,5,5h50c2.75,0,5-2.25,5-5V5C60,2.25,57.75,0,55,0L55,0z' })
      )
    )
  );
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=Icon_Visa.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-credit-card-icons/lib/Icon_Visa.js
// module id = 1081
// module chunks = 0